// extracted by mini-css-extract-plugin
export var contactUs = "ContactUs-module--contact-us--12b54";
export var contactUsContainer = "ContactUs-module--contact-us-container--5e6e3";
export var label = "ContactUs-module--label--e943d";
export var labelTravelAgent = "ContactUs-module--label-travel-agent--69f2e";
export var phoneNumber = "ContactUs-module--phone-number--979db";
export var phoneNumberDisclaimer = "ContactUs-module--phone-number-disclaimer--a2e2d";